import { escapeHTML } from '../../utils/escape.js';

const ESTADO_LABELS = {
    both: 'Ambos (Take Away + Delivery)',
    takeaway: 'Solo Take Away',
    none: 'Ninguno (oculto en pedidos)',
};

const ESTADO_OPTIONS = ['both', 'takeaway', 'none'];

/**
 * Vista de reglas de orden por categoría para el panel de staff.
 * Devuelve HTML sin estado ni efectos. Muestra cada categoría con su estado
 * actual y un dropdown inline para cambiarlo.
 *
 * @param {{ categories: Array<{ id: string, name: string }>, rules: Record<string, 'both'|'takeaway'|'none'> }} viewModel
 * @returns {string}
 */
export const CategoriesView = ({ categories, rules }) => {
    if (!categories || categories.length === 0) {
        return `
            <div class="flex flex-col items-center justify-center py-16 text-center" role="status">
                <p class="text-sm font-bold text-text-muted">No se encontraron categorías en Fudo.</p>
            </div>
        `;
    }

    const sorted = [...categories].sort((a, b) => a.name.localeCompare(b.name));

    return `
        <section aria-label="Reglas de orden por categoría" class="max-w-3xl">
            <span class="block text-[10px] font-black uppercase tracking-[0.2em] text-text-muted mb-2">Pedidos</span>
            <h2 class="text-2xl font-black uppercase tracking-tight text-text-primary mb-2">Reglas por categoría</h2>
            <p class="text-xs text-text-muted mb-8 max-w-prose">
                Cada categoría define qué productos se muestran en la app de pedidos según el tipo de orden (Take Away o Delivery).
            </p>
            <div class="bg-surface border border-border-subtle rounded-2xl divide-y divide-border-subtle">
                ${sorted.map(cat => {
                    const estado = rules[cat.id] ?? 'both';
                    return `
                        <div class="flex items-center justify-between gap-4 px-5 py-4">
                            <span class="text-xs font-bold text-text-primary flex-1 min-w-0 truncate">${escapeHTML(cat.name)}</span>
                            <select data-action="cat-rule-change" data-category-id="${escapeHTML(String(cat.id))}"
                                class="bg-base border border-border-subtle rounded-xl py-2 px-3 text-xs font-bold text-text-primary focus:outline-none focus:border-brand shrink-0">
                                ${ESTADO_OPTIONS.map(opt => `
                                    <option value="${opt}" ${estado === opt ? 'selected' : ''}>${ESTADO_LABELS[opt]}</option>
                                `).join('')}
                            </select>
                        </div>
                    `;
                }).join('')}
            </div>
        </section>
    `;
};
